<template>
	<div class="test-page">
		<h1>Test page</h1>
	</div>
</template>

<script>
	
	export default {
		created() {
			
		}
	}
</script>